function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { createQueryDefinition, createQueryHook } from "../queryBuilder";
import { keys as keysFn, get as getFn, update as updateFn, oldKeys, oldGet } from "./api";
export var GetConfigKeysQuery = createQueryDefinition(function(isNewConfigUapiEnabled) {
    return [
        "config",
        "keys",
        isNewConfigUapiEnabled
    ];
}, function(param) {
    var _param_queryKey = _slicedToArray(param.queryKey, 3), isNewConfigUapiEnabled = _param_queryKey[2];
    return isNewConfigUapiEnabled ? keysFn() : oldKeys();
});
export var useConfigKeysQuery = createQueryHook(GetConfigKeysQuery, {
    select: function(param) {
        var data = param.data;
        return data;
    }
});
export var queryGetConfig = createQueryDefinition(function(eventId, isNewConfigUapiEnabled) {
    return [
        "config",
        String(eventId),
        isNewConfigUapiEnabled
    ];
}, function(param) {
    var _param_queryKey = _slicedToArray(param.queryKey, 3), eventId = _param_queryKey[1], isNewConfigUapiEnabled = _param_queryKey[2];
    return isNewConfigUapiEnabled ? getFn(eventId) : oldGet(eventId);
});
export var useConfigQuery = createQueryHook(queryGetConfig, {
    select: function(param) {
        var data = param.data;
        return data;
    }
});
export var useConfigUpdateMutation = function() {
    var queryClient = useQueryClient();
    return useMutation({
        mutationFn: function(param) {
            var eventId = param.eventId, configs = param.configs;
            return updateFn(eventId, configs);
        },
        onSuccess: function() {
            queryClient.invalidateQueries({
                queryKey: [
                    "config"
                ]
            });
        }
    });
};
